import { __assign, __rest } from "tslib";
/* eslint-disable filenames/match-exported */
// ^ This component is a subcomponent so it uses a `Form.Subcomponent` filename
import React from 'react';
import PropTypes from 'prop-types';
import formValidationRulesPropType from '../propTypes/formValidationRulesPropType';
import TextInput from './TextInput';
import useFormInput from '../hooks/useFormInput';
var FormTextInput = function (_a) {
    var initialValue = _a.initialValue, label = _a.label, name = _a.name, rules = _a.rules, props = __rest(_a, ["initialValue", "label", "name", "rules"]);
    var _b = useFormInput({
        name: name,
        initialValue: initialValue,
        label: label,
        rules: rules
    }), errorMessage = _b.errorMessage, isRequired = _b.isRequired, onBlur = _b.onBlur, onChange = _b.onChange, value = _b.value;
    var handleOnChange = function (text) {
        // added condition to handle empty space when required is true
        // avoided use of trim method as we may get number and trim will not work with number
        return onChange(text === ' ' ? null : text);
    };
    return (React.createElement(TextInput, __assign({}, props, { errorMessage: errorMessage, isRequired: isRequired, label: label, onBlur: onBlur, onChange: handleOnChange, value: value })));
};
FormTextInput.propTypes = {
    initialValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.node,
    name: PropTypes.string.isRequired,
    rules: formValidationRulesPropType
};
export default FormTextInput;
//# sourceMappingURL=Form.TextInput.js.map